import { useSpaceNotificationsState } from "@circle-react/contexts/sidebarNotificationsContext";

import { getSpaceSidebarBadgeCount } from "./utils";

export interface SpaceUnreadState {
  badgeCount: string;
  hasNotifications: boolean;
  hasUnreadContent: boolean;
}

export const useSpaceUnreadState = (spaceId?: number): SpaceUnreadState => {
  const { spacesById } = useSpaceNotificationsState();

  const { unread_content_count = 0, unread_notifications_count = 0 } =
    (spaceId === undefined ? undefined : spacesById[spaceId]) ?? {};
  const hasUnreadContent = unread_content_count > 0;
  const hasNotifications = unread_notifications_count > 0;

  return {
    badgeCount: getSpaceSidebarBadgeCount(
      unread_content_count,
      unread_notifications_count,
    ),
    hasNotifications,
    hasUnreadContent,
  };
};
